import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useDocumentMeta } from "../lib/useDocumentMeta";

export default function NotFound() {
  useDocumentMeta({ title: "Page not found", description: "Find the PX7 Training home page, method and articles." });
  // Keep client-side navigation consistent with the Worker's 404 response.
  useEffect(() => {
    const existing = document.querySelector<HTMLMetaElement>('meta[name="robots"]');
    const created = !existing;
    const previousContent = existing?.content;
    const meta = existing ?? document.createElement("meta");
    meta.name = "robots";
    meta.content = "noindex, follow";
    if (created) document.head.appendChild(meta);
    return () => {
      if (created) meta.remove();
      else meta.content = previousContent!;
    };
  }, []);

  return (
    <section className="mk-container py-24 text-center">
      <p className="mk-eyebrow">404</p>
      <h1 className="mk-h1 mt-3">Page not found.</h1>
      <p className="mk-lead mt-4 max-w-lg mx-auto">
        We couldn't find that page. Continue from the home page or browse the articles.
      </p>
      <div className="mt-6">
        <Link to="/" className="mk-button-ghost text-base">← Home</Link>
        <Link to="/articles" className="mk-button-ghost text-base ml-3">Articles →</Link>
      </div>
    </section>
  );
}
